<template>
  <div class="pe-biz-sticky-tab">
    <div v-if="props.title" class="pe-biz-sticky-tab-header">{{ props.title }}</div>
    <slot></slot>
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from "vue";

type Props = {
  title?: string;
};
const props = defineProps<Props>();

</script>

<style scoped lang="scss">
.pe-biz-sticky-tab {
  margin-bottom: 30px;
}
.pe-biz-sticky-tab-header {
  margin-bottom: 15px;
}
</style>